export function useVideoLocaleUrl() {
  const { locale } = useI18n();

  function getVideoLocaleUrl(videoName: string, path = 'video'): string {
    switch (locale.value) {
      case 'es':
        return `/${path}/es/ES_${videoName}`;
      case 'es-mx':
        return `/${path}/mx/MX_${videoName}`;
      case 'de':
        return `/${path}/de/DE_${videoName}`;
      case 'pt':
        return `/${path}/pt/PT_${videoName}`;
      case 'pt-br':
        return `/${path}/br/BR_${videoName}`;
      case 'fr':
        return `/${path}/fr/FR_${videoName}`;
      case 'it':
        return `/${path}/it/IT_${videoName}`;
      case 'en':
      default:
        return `/${path}/en/EN_${videoName}`;
    }
  }

  return {
    getVideoLocaleUrl,
  };
}
